import DeauvilleMay2026 from "../../components/before-after/DeauvilleMay2026";

const DeauvilleMay2026View = () => {

    return (
        <div className="before-after-deauville-may-2026">
            <DeauvilleMay2026/>
        </div>
    );
};

export default DeauvilleMay2026View;